// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"55b8732648088706","6831":"5bfe270f7671daa4","8503":"c4f84652b0ee485d","9683":"3daacc8923e7b27a"}[chunkId] + ".js";
};